module.exports = __webpack_public_path__ + "img/52002761_L.780861e3.png";